/**
 * 业务组件样式定义
 * 定义业务相关组件的样式
 */

import { SxProps, Theme } from "@mui/material/styles";

// 错误消息区域样式
export const errorMessageAreaStyles: Record<string, SxProps<Theme>> = {
  // 基础样式
  root: {
    backgroundColor: "error.light",
    color: "error.contrastText",
    padding: 2,
    borderRadius: "0px",
    marginBottom: 2,
  },

  // 错误消息文本样式
  text: {
    color: "error.contrastText",
  },

  // 关闭按钮样式
  closeButton: {
    color: "error.contrastText",
    "&:hover": {
      backgroundColor: "rgba(255,255,255,0.1)",
    },
  },

  // 错误消息样式
  errorMessage: {
    backgroundColor: "error.light",
    color: "error.contrastText",
    padding: 2,
    borderRadius: "0px",
    marginBottom: 2,
  },

  // 主样式
  main: {
    height: 300,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
};

// ErrorBoundary 组件样式
export const errorBoundaryStyles: Record<string, SxProps<Theme>> = {
  // 容器样式
  container: {
    p: 3,
  },

  // 警告样式
  alert: {
    mb: 2,
  },

  // 错误详情样式
  errorDetails: {
    mt: 2,
    p: 2,
    backgroundColor: "#f5f5f5",
    borderRadius: 1,
  },

  // 错误文本样式
  errorText: {
    mb: 2,
  },

  // 错误堆栈样式
  errorStack: {
    fontSize: "0.8rem",
  },
};

// 输入框基础样式
export const inputBaseStyles: Record<string, SxProps<Theme>> = {
  // 基础样式
  root: {
    // 基础输入框样式定义
  },
};

// 导出所有业务组件样式
export default {
  errorMessageAreaStyles,
  errorBoundaryStyles,
  inputBaseStyles,
};
